import React from 'react';
import ReactApexChart from 'react-apexcharts';

const BarChart = ({
    chartSeries,
    colors,
    categories,
    width,
    max,
    percentage
}) => {
    const chartOptions = {
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false,
                tools: {
                    download: false,
                }
            }
        },
        dataLabels: {
            enabled: false // Move this inside plotOptions.bar
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: false,
                columnWidth: width || '10%',
            },
        },
        xaxis: {
            categories: categories || ['Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            axisBorder: {
                show: true,
                color: '#e0e0e0'
            },
            axisTicks: {
                show: true,
                color: '#e0e0e0'
            }
        },
        yaxis: {
            min: 0,
            max: max || 100,
            labels: {
                formatter: function (val) {
                    return percentage ? val + '%' : val;
                }
            },
            axisBorder: {
                show: true, // This adds border to Y-axis
                color: '#e0e0e0',
                width: 2
            },
            axisTicks: {
                show: true, // Show ticks on Y-axis
                color: '#e0e0e0'
            }
        },
        grid: {
            show: true,
            borderColor: '#e7e7e7',
            strokeDashArray: 5,
            yaxis: {
                lines: {
                    show: true // Show horizontal grid lines
                }
            },
            xaxis: {
                lines: {
                    show: false // Hide vertical grid lines
                }
            }
        },
        colors: colors,
        legend: {
            position: 'bottom',
            horizontalAlign: 'center',
        }
    };

    return (
        <ReactApexChart
            options={chartOptions}
            series={chartSeries}
            type="bar"
            height={350}
        />
    );
};

export default BarChart;